export default __webpack_public_path__ + "static/media/Third_party_address_form.89b4fc68.svg";